module.exports = __webpack_public_path__ + "d315f76acc416c38ab68ca7032efb324.png";